import React, { ReactNode } from "react";
import classnames from "classnames";
import { observer } from "mobx-react";

import { Uuid } from "@formant/core/model/Uuid";
import { Icon, IconSize } from "@formant/ui/component/common/Icon";

import { useRouter } from "../../context/RouterContext";
import { useStores } from "../../context/StoreContext";
import * as styles from "./DeviceName.scss";
import { TextButton } from "./TextButton";

interface IDeviceLinkProps {
    name: string;
    id: Uuid;
    children: ReactNode;
}

const NoLink = ({ children }: IDeviceLinkProps) => <>{children}</>;
const DeviceLink = ({ name, id, children }: IDeviceLinkProps) => {
    const { routeTo } = useRouter();
    return (
        <TextButton
            to={routeTo.device({ id })}
            className={classnames(styles.device, styles.button)}
            data-tooltip={name}
        >
            {children}
        </TextButton>
    );
};

export interface IDeviceNameProps {
    id: Uuid;
    className?: string;
    size?: IconSize;
    showIcon?: boolean;
    isLink?: boolean;
}

export const DeviceName = observer(function DeviceName(
    props: IDeviceNameProps,
) {
    const { id, className, size, showIcon = true, isLink = true } = props;
    const { authStore, deviceDetailsStore } = useStores();
    const { name } = (id && deviceDetailsStore.get(id)) || { name: "" };

    let LinkWrapper;
    if (isLink) {
        LinkWrapper = authStore.shareCode ? NoLink : DeviceLink;
    } else {
        LinkWrapper = NoLink;
    }

    return (
        <div className={classnames(styles["device-name"], className)}>
            {name && (
                <LinkWrapper id={id} name={name}>
                    {showIcon && <Icon name="device" size={size} />}
                    <div>{name}</div>
                </LinkWrapper>
            )}
        </div>
    );
});
